<script setup lang="ts">
import { Web3authFooter } from "@toruslabs/vue-components";
import { Modal } from "@toruslabs/vue-components/Modal";
import { onBeforeMount } from "vue";

onBeforeMount(() => {
  const html = document.getElementsByTagName("html")[0];
  const body = document.getElementsByTagName("body")[0];
  html.style.background = "transparent";
  body.style.background = "transparent";
});

const closeModal = () => {
  window.parent.postMessage("close-nft-checkout", "*");
};
</script>

<template>
  <Modal
    :open="true"
    :classes="{
      modalContent:
        '@container/wallet !overflow-hidden !rounded-3xl w-[390px] !h-[500px] border-0 py-4 px-6 !bg-app-light-surface1 dark:!bg-app-dark-surface1',
      clearIcon: '!top-3 !right-3',
      body: '!p-0 h-full flex flex-col gap-3',
    }"
    :backdrop-blur="true"
    :backdrop-close="false"
    @on-close="closeModal()"
  >
    <template #body>
      <slot />
      <Web3authFooter :classes="{ container: '!mt-0' }" />
    </template>
  </Modal>
</template>
